import { createSelectorV8 } from "../../../utils/createSelector.js";
import { GridEditModes } from "../../../models/gridEditRowModel.js";
/**
 * Select the row editing state.
 */ export var gridEditRowsStateSelector = function(state) {
    return state.editRows;
};
export var gridRowIsEditingSelector = createSelectorV8(gridEditRowsStateSelector, function(editRows, param) {
    var rowId = param.rowId, editMode = param.editMode;
    return editMode === GridEditModes.Row && Boolean(editRows[rowId]);
});
export var gridEditCellStateSelector = createSelectorV8(gridEditRowsStateSelector, function(editRows, param) {
    var rowId = param.rowId, field = param.field;
    var _editRows_rowId;
    var _editRows_rowId_field;
    return (_editRows_rowId_field = (_editRows_rowId = editRows[rowId]) === null || _editRows_rowId === void 0 ? void 0 : _editRows_rowId[field]) !== null && _editRows_rowId_field !== void 0 ? _editRows_rowId_field : null;
});
